module.exports = __webpack_public_path__ + "static/media/ico-ofertas-006.593802bf.svg";